import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { Button, Icon } from '@emburse/embark-core';
import { FileUploadIcon } from '@emburse/embark-icons';
function FileUploadButton({ onFileSelect, accept, color, children, disabled, fullWidth, multiple, onClick, size, variant, noIcon }) {
    const fileInput = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { color: color, disabled: disabled, size: size, startIcon: !noIcon ? _jsx(Icon, { iconUrl: FileUploadIcon }) : '', fullWidth: fullWidth, variant: variant, onClick: (event) => {
                    if (onClick) {
                        onClick(event);
                    }
                    fileInput.current.click();
                }, children: children }), _jsx("input", { type: "file", multiple: multiple, accept: accept, hidden: true, ref: fileInput, onChange: onFileSelect })] }));
}
FileUploadButton.defaultProps = {
    onSelect: () => { },
    multiple: false,
    accept: '',
    noIcon: false
};
export default FileUploadButton;
